module.exports = __webpack_public_path__ + "static/media/WheelAssy.53d05b96.glb";